import { render } from "./guide.vue?vue&type=template&id=feca955c&scoped=true&ts=true"
import script from "./guide.vue?vue&type=script&lang=ts"
export * from "./guide.vue?vue&type=script&lang=ts"

import "./guide.vue?vue&type=style&index=0&id=feca955c&scoped=true&lang=scss"

import exportComponent from "/home/build/jenkins/workdir/workspace/fast-build/fast-build/67161/vshow-main/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feca955c"]])

export default __exports__